import React from "react";
import "./Header.css";
import CTA from "./CTA";
import HeaderSocials from "./HeaderSocials";

function Header() {
  return (
    <>
      <header>
        <div className="container container_hader">
          <h5>Hello I'm</h5>
          <h1>Darshil Jetani</h1>
          <h5 className="text-light">Web Developer</h5>
          <CTA />
          <HeaderSocials/>
          <div className="me">
            <img src="./assets/me (2).png" alt="" />
          </div>
          <a href="#contact" className="scroll__down">Scroll Down</a>
        </div>
      </header>
    </>
  );
}

export default Header;
